import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule } from "@angular/forms";
import { SharedModule } from "./shared";
import { appRouter } from "./app.router";
import { HttpClientModule } from "@angular/common/http";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    appRouter // ✔️ RouterModule with correct generic
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
